'use client'

import type {TestingType} from '../../types'
import {observer} from 'mobx-react'
import React, {useEffect} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {z} from 'zod'

import {FormTemplate} from '@/src/shared/modules/form/ui/template'
import {useFormTesting} from '@/src/features/functional-testing'
import {FormTestingStep} from '@/src/features/functional-testing/store'

import {useStore} from '@/src/shared/hooks/useStore'
import Radio from '@/src/shared/ui/inputs/radio'
import {sanitizeHtml} from '@/src/shared/utils/functions'

import * as UI from './testing-type-form.styled'

export type TestTypeFormData = {
  type_id: Id
}

export const TestTypeFormSchema = z.object({
  type_id: z.string().or(z.number()),
})

export const TestingTypeForm = observer(() => {
  const form = useFormContext<TestTypeFormData>()
  const testingFormStore = useFormTesting()

  const testingTypeId = form.watch('type_id')

  const {pageData} = useStore<{types: TestingType[]}>()
  const {types} = pageData!.content

  const onSubmit = form.handleSubmit(() => {
    if (testingFormStore.step === FormTestingStep.SelectTypeTesting) {
      testingFormStore.advance(FormTestingStep.SelectLab)
    }
  })

  useEffect(() => {
    if (testingTypeId) {
      testingFormStore.setTypeId(testingTypeId)
      onSubmit()
    }
  }, [testingTypeId])

  return (
    <FormTemplate title="Выберите тип тестирования:">
      <SelectGroup types={types} />
    </FormTemplate>
  )
})

interface SelectProps {
  types: TestingType[]
  id?: Id
}

const SelectGroup = observer(({types}: SelectProps) => {
  const form = useFormContext<TestTypeFormData>()
  const testingFormStore = useFormTesting()
  const id = form.watch('type_id')

  return (
    <UI.SelectGroup>
      <Controller
        name={'type_id'}
        control={form.control}
        render={({field}) => (
          <>
            {types.map(testType => (
              <UI.Item key={testType.id} onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                form.setValue('type_id', testType.id)
                if (testType.id === id && testingFormStore.step === FormTestingStep.SelectTypeTesting) {
                  testingFormStore.advance(FormTestingStep.SelectLab)
                }
              }}>
                <UI.Name>
                  <UI.Radio
                    key={`type-id-${testType.id}`}
                    name={'type_id'}
                    as={Radio}
                    field={field}
                    value={testType.id}
                    checked={testType.id === id}
                    suppressOnChange
                  >
                    {testType.title}
                  </UI.Radio>
                </UI.Name>
                {testType.description && (
                  <UI.Description dangerouslySetInnerHTML={{__html: sanitizeHtml(testType.description)}} />
                )}
              </UI.Item>
            ))}
          </>
        )}
      />
    </UI.SelectGroup>
  )
})
